<template>
  <div class="Login">
    <div class="logo">
      <img class="icon-logo" src="@ass/logo.png" alt />
    </div>
    <div class="loginTab">
      <van-tabs
        color="#6270F6"
        class="loginNav"
        title-inactive-color="#DBDBDB"
        title-active-color="#6270F6"
        background="rgba(0,0,0,0)"
        :border="false"
        animated
      >
        <van-tab disabled></van-tab>

        <!-- 用户名登录 -->
        <van-tab title="用户名登录" name="pawUp">
          <div class="cont-put">
            <importemp
              v-model="params.userNameOrEmailAddress"
              :icon="require('@ass/dealer/icon-user.png')"
              placeholder="请输入用户名"
            />
            <importemp
              v-model="params.password"
              type="password"
              :icon="require('@ass/dealer/icon-suo.png')"
              placeholder="请输入密码"
            />

            <!-- <div class="line-info">
                            <span class="line-">没有账号?</span>
                            <span class="line--" @click="registerEvent">快速注册</span>
                        </div> -->
            <div class="btnConten">
              <van-button color="#6270F6" round block @click="loginEvent"
                >登录</van-button
              >
            </div>
          </div>
        </van-tab>
        <van-tab disabled></van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
// import * as sessiondate from '../service/staticData'
import importemp from "@com/importemp";
export default {
  name: "Login",

  components: {
    importemp,
  },

  data() {
    return {
      verifyCode: "",
      params: {
        userNameOrEmailAddress: "",
        password: "",
        rememberMe: true,
      },
    };
  },

  //   created(){
  //       window.location.href=sessiondate.weixin;
  //   }
  mounted() {
    // 清除本地 token  userinfo 数据
  },

  methods: {
    // 密码登录
    loginEvent() {
      let { rememberMe, userNameOrEmailAddress, password } = this.params;
      if (userNameOrEmailAddress && password) {
        this.fetchpost("/api/account/login", {
          rememberMe,
          userNameOrEmailAddress,
          password,
        })
          .then((res) => {
            if (res.status == "ok") {
              localStorage.setItem("token", res.message);

              localStorage.setItem(
                "Payment.Default.List",
                res.permissions.indexOf("Payment.Default.List") >= 0
              );

              this.$toast("登陆成功");
              this.$router.push("/home/homePage");
            } else {
              this.$toast.fail("账号或者密码错误");
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.$toast("请输入完整信息！！");
      }
    },
    // 注册
    registerEvent() {
      this.$router.push("/register");
    },
  },
};
</script> 

<style lang="scss" scoped>
.Login {
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
  .logo {
    text-align: center;
    margin-top: 80px;
    .icon-logo {
      height: 75px;
      width: 123px;
    }
  }
  .loginTab {
    margin-top: 29px;
    .verCode {
      width: 69px;
      height: 29px;
      background: #eaeaea;
      margin-top: 6px;
    }
    .line-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      font-size: 15px;
      .line- {
        color: #666666;
        margin-left: 10px;
      }
      .line-- {
        color: #6270f6;
        margin-right: 10px;
      }
    }
  }
  .btnConten {
    padding: 30px 20px 10px 20px;
  }
}
</style>
<style lang="scss">
.loginNav {
  .van-tab {
    font-size: 14px;
    color: #f9f9f9;
    transition: transform 0.3s;
  }
  .van-tab--active {
    transform: scale(1.1);
    color: #ffffff;
  }
  .van-tabs__content {
    margin-top: 60px;
    background: #ffffff;
    .cont-put {
      padding: 0 20px;
    }
  }
}
</style>